import React from 'react';
import Header from '../components/Header';
import '../styles/theme.css';

const Analytics = () => {
  return (
    <div className="max-w-7xl">
      <Header title="Analytics" />
      
      <div className="card p-12 text-center">
        <div className="text-6xl mb-4">📈</div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Analytics Coming Soon</h2>
        <p className="text-gray-600">
          Track your review performance, response rates, and customer sentiment.
        </p>
      </div>

      {/* Placeholder Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
        <div className="card p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Response Rate</h3>
          <p className="text-3xl font-bold text-blue-600">--</p>
          <p className="text-sm text-gray-600 mt-2">Coming soon</p>
        </div>
        
        <div className="card p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Avg. Rating</h3>
          <p className="text-3xl font-bold text-green-600">--</p>
          <p className="text-sm text-gray-600 mt-2">Coming soon</p>
        </div>
        
        <div className="card p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Response Time</h3>
          <p className="text-3xl font-bold text-purple-600">--</p>
          <p className="text-sm text-gray-600 mt-2">Coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
